import { IApplicationsState } from "./reducer";

interface IWithAppsState {
  features: {
    applications: IApplicationsState;
  };
}

export function selectLoadedWidgets(state: IWithAppsState): string[] {
  return state.features.applications.loadedWidgets;
}

export function getLoadedFullscreenWidgets(state: IWithAppsState): string[] {
  return state.features.applications.loadedFullscreenWidgets;
}

export function getWidgetsEnabled(state: IWithAppsState): boolean {
  return state.features.applications.widgetsEnabled;
}
